import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiUsers, FiAward } = FiIcons;

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://i.postimg.cc/DZjtbDYx/2026-01-23-08-41-27.jpg" 
                alt="Manchester Local Engineers" 
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-blue-600 text-white p-8 rounded-3xl shadow-xl hidden md:block">
              <div className="text-4xl font-extrabold mb-1">15+</div>
              <div className="text-sm font-bold uppercase tracking-wider">Years Serving<br />Manchester</div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-blue-600 font-bold uppercase tracking-widest mb-4">About Us</h2>
            <h3 className="text-4xl font-extrabold text-gray-900 mb-6">
              Fast, Local Drainage Experts — <span className="text-blue-600">24/7 Service You Can Rely On</span>
            </h3>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              From blocked drains to overflowing manholes, our skilled local engineers are ready to respond — fast. 
              Rapid Drainage Solutions provides expert drainage services around the clock, with no hidden fees and no job too big or small.
            </p>
            
            <div className="grid sm:grid-cols-2 gap-4">
              {[
                "Family-run since 2009",
                "Manchester & surroundings",
                "15-minute callback time",
                "3-hour arrival guaranteed",
                "Fixed fee — no surcharges",
                "Qualified & polite team"
              ].map((item, i) => (
                <div key={i} className="flex items-center space-x-3 text-gray-800 font-semibold">
                  <div className="bg-blue-100 p-1 rounded-full">
                    <SafeIcon icon={FiCheck} className="text-blue-600" />
                  </div>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;